import React, { Component } from 'react';

import formCss from './forms.css';
import css from './editable-textfield.css';

// Material UI Library
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import NavigationCheck from 'material-ui/svg-icons/navigation/check';

class EditableSelectField extends Component {

  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      saving: false,
    };
  }

  componentWillReceiveProps(newProps) {
    if (this.state.saving && this.props.value !== newProps.value) {
      this.setState({
        editMode: false,
        saving: false,
      });
    }
  }

  handleFocus = (e) => {
    e.preventDefault();
    this.setState({ editMode: true });
  };

  cancelEdit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ editMode: false });
  };

  handleItemSelect = (e, i, newValue) => {
    this.props.saveValue(newValue);
  };

  render() {
    return (
      <SelectField
        value={this.props.value}
        hintText={this.props.hintText}
        onChange={this.handleItemSelect}
        style={{ margin: '0 10px' }}
      >
        {this.props.collection.get('result').map(id =>
          <MenuItem
            key={this.props.collection.get('entities').get(`${id}`).get('slug')}
            value={this.props.collection.get('entities').get(`${id}`).get('id')}
            primaryText={this.props.collection.get('entities').get(`${id}`).get('name')}
          />
        )}
      </SelectField>
    );
  }
}

export default EditableSelectField;



/** WEBPACK FOOTER **
 ** ./components/forms/EditableSelectField.js
 **/